/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Openquestionskindamount3Inputs */

const en_openquestionskindamount3 = /** @type {(inputs: Openquestionskindamount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amount`)
};

const pt_openquestionskindamount3 = /** @type {(inputs: Openquestionskindamount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor`)
};

/**
* | output |
* | --- |
* | "Amount" |
*
* @param {Openquestionskindamount3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const openquestionskindamount3 = /** @type {((inputs?: Openquestionskindamount3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Openquestionskindamount3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_openquestionskindamount3(inputs)
	return pt_openquestionskindamount3(inputs)
});
export { openquestionskindamount3 as "openQuestionsKindAmount" }